module.exports = __webpack_public_path__ + "static/media/Archivo_002.e74d15ff.jpeg";